var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMyOffers = function SvgMyOffers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.5,
    height: 40.603,
    viewBox: "0 0 37.5 40.603",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(1033.816 -490.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M-1015.217,529.066h-15.471a1.883,1.883,0,0,1-1.878-1.877v-28.27a1.883,1.883,0,0,1,1.878-1.878h2.3",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M-1009.922,497.041h2.392a1.883,1.883,0,0,1,1.878,1.878v10.539",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M-997.566,521.246a8.659,8.659,0,0,1-8.659,8.658,8.659,8.659,0,0,1-8.658-8.658,8.658,8.658,0,0,1,8.658-8.658A8.658,8.658,0,0,1-997.566,521.246Z",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M-1010.184,520.91l3.521,2.861,4.511-5.831",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M-1012.883,494.868h-3.136a3.127,3.127,0,0,0-3.123-3.067,3.127,3.127,0,0,0-3.124,3.067h-3.135v4.776h12.518Z",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1160",
    "data-name": "Rectangle 1160",
    width: 0.539,
    height: 0.538,
    transform: "translate(-1026.947 506.496)",
    strokeWidth: 2.5,
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#475257"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x2: 12.721,
    transform: "translate(-1022.93 506.765)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1161",
    "data-name": "Rectangle 1161",
    width: 0.539,
    height: 0.538,
    transform: "translate(-1026.947 511.538)",
    strokeWidth: 2.5,
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#475257"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x2: 9.591,
    transform: "translate(-1022.93 511.808)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1162",
    "data-name": "Rectangle 1162",
    width: 0.539,
    height: 0.539,
    transform: "translate(-1026.947 516.581)",
    strokeWidth: 2.5,
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#475257"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x2: 5.765,
    transform: "translate(-1022.93 516.85)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1163",
    "data-name": "Rectangle 1163",
    width: 0.539,
    height: 0.539,
    transform: "translate(-1026.947 521.623)",
    strokeWidth: 2.5,
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#475257"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    x2: 4.9,
    transform: "translate(-1022.93 521.892)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyOffers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MyOffers.3e04f318.svg";
export { ForwardRef as ReactComponent };